module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-up.93bedc52.svg";